import React from "react";
import { Globe } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useT } from "@/i18n/I18nContext";

const LANGS = [
  { code: "en", labelKey: "lang.english", short: "EN" },
  { code: "ro", labelKey: "lang.romanian", short: "RO" },
];

export const LanguageSwitcher = ({ variant = "ghost" }) => {
  const { lang, setLang, t } = useT();
  const current = LANGS.find((l) => l.code === lang) || LANGS[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={variant} size="sm" className="gap-1.5 px-2" aria-label={t("lang.label")} data-testid="language-switcher">
          <Globe className="h-4 w-4" />
          <span className="text-xs font-semibold">{current.short}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => setLang(l.code)}
            className={lang === l.code ? "font-semibold text-[hsl(var(--brand))]" : ""}
            data-testid={`language-option-${l.code}`}
          >
            <span className="mr-2 text-[11px] font-mono text-muted-foreground">{l.short}</span>
            {t(l.labelKey)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
